import { render, staticRenderFns } from "./AppPrematchOdds.vue?vue&type=template&id=36563520&"
import script from "./AppPrematchOdds.vue?vue&type=script&lang=js&"
export * from "./AppPrematchOdds.vue?vue&type=script&lang=js&"
import style0 from "./AppPrematchOdds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports